<template>
    <button :disabled="disabled">
        <spinner :loading="loading" class="fa-lg" />
        <span v-cloak v-show="!loading">
            <slot />
        </span>
    </button>
</template>

<script>
export default {
    props: [
        'loading',
        'disabled',
    ],

    data: () => ({}),

    created() {
        //
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
